module.exports = __webpack_public_path__ + "static/media/max.3aac0150.png";